<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">Shipping Advice</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!editable || hasSjlSend"
          @click="save"
          v-permit.SHARP_SA_SAVE
          >{{ $t("app.buttons.temporarySave") }}</v-btn
        >
        <v-btn
          v-if="hasSendMail"
          @click="saUpdateAfterSendMail"
          v-permit.SHARP_SA_SAVE
          >SA変更</v-btn
        >
        <v-btn
          :disabled="!editable"
          @click="formalSave"
          v-permit.SHARP_SA_CONFIRM
          v-show="
            (sa.shipmentType === 'PRESA' || sa.shipmentType === 'FORMALSA') &&
            sa.blNo
          "
          >保存</v-btn
        >
        <v-btn
          :disabled="sa.id == null"
          @click="cancelSa"
          v-permit.SHARP_SA_CANCEL
          v-show="canCancel"
          >SA取消</v-btn
        >
        <v-btn
          :disabled="
            sa.id == null ||
            !sa.isInternationalArchive ||
            sa.hasAnyChildConfirmed ||
            sa.status === '凍結後SA取消申請済み'
          "
          @click="cancelArchivedSa"
          v-permit.SHARP_SA_ARCHIVE_CANCEL_APPLY
          v-show="canCancel"
          >凍結後SA取消申请</v-btn
        >

        <v-btn
          :disabled="sa.status !== '凍結後SA取消申請済み'"
          @click="archiveCancelApprove"
          v-permit.SHARP_SA_ARCHIVE_CANCEL_APPROVE
          v-show="canCancel"
          >凍結後SA取消承認</v-btn
        >

        <v-btn @click="turnBack" v-show="canBlTurnBack">一時保存戻す</v-btn>

        <v-btn
          :disabled="
            sa.id == null ||
            !sa.isInternationalArchive ||
            sa.hasAnyChildConfirmed ||
            sa.status === '凍結後SA一時保存戻し申請済み'
          "
          @click="cancelArchivedSa"
          v-show="canBlTurnBack"
          v-permit.SHARP_SA_ARCHIVE_TURN_BACK_APPLY
          >凍結後SA一時保存戻す申请</v-btn
        >

        <v-btn
          :disabled="sa.status !== '凍結後SA一時保存戻し申請済み'"
          @click="archiveCancelApprove"
          v-show="canBlTurnBack"
          v-permit.SHARP_SA_ARCHIVE_TURN_BACK_APPROVE
          >凍結後SA一時保存戻す承認</v-btn
        >

        <v-btn @click="goBack">{{ $t("app.buttons.back") }}</v-btn>
        <v-btn
          :disabled="sa.id == null || !editable"
          @click="send"
          v-permit.SHARP_SA_CONFIRM
          v-show="sa.shipmentType === 'SA' || sa.shipmentType === 'PARTNERSA'"
          >{{ $t("app.buttons.send") }}</v-btn
        >
        <v-btn
          v-if="sa.partnerId"
          :disabled="
            !sa.id ||
            sa.sjlSend ||
            sa.status === '海外取引先登録済' ||
            sa.actStatus === '海外取引先登録済'
          "
          @click="sjlSend()"
          v-permit.SHARP_SA_SJL_SEND
          >{{ isSytc ? "納入送信画面へ" : $t("B0400.titles[6]") }}</v-btn
        >
        <v-btn
          :disabled="!sa.id || sa.sjlSend"
          @click="sytcSend()"
          v-permit.SHARP_SA_SYTC_SEND
          >{{ $t("B0400.titles[7]") }}</v-btn
        >
        <v-btn
          :disabled="!canUpload"
          @click="uploadFile"
          v-permit.SHARP_SA_FILE_UPLOAD
          >{{ $t("app.buttons.fileUpload") }}</v-btn
        >
        <v-btn
          @click="openEta"
          v-permit.SHARP_SA_ETA_UPDATE
          v-show="!editable && $route.path.indexOf('new') === -1"
          >{{ $t("app.buttons.openEta") }}</v-btn
        >
        <v-btn
          @click="partnerSaTurnBack"
          v-permit.SHARP_SA_CONFIRM
          v-show="sa.shipmentType === 'PARTNERSA'"
          >SA戻す(シッパー)</v-btn
        >
        <v-btn
          v-show="sa.id && canCancel && isSeaFcl"
          :disabled="selected.length !== 1"
          @click="updateContainerNo"
          >コンテナNo更新</v-btn
        >
        <a @click="$downloadTemplate('B0400', 'excel')" href="#"
          >Excel template</a
        >
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-card-title primary-title style="padding-left: 8px">
        <span class="headline mb-0">{{ $t("B0400.titles[1]") }}</span>
      </v-card-title>
      <v-form lazy-validation ref="form" v-model="valid" value>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                disabled
                :label="$t('app.labels.company.name')"
                required
                url="companies/kv?type=SHARP"
                v-model="sa.companyId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.partner') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                disabled
                key="partner"
                url="companies/kv?type=PARTNER"
                v-model="sa.partnerId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="!editable"
                :label="$t('app.labels.masterBlNo')"
                :rules="
                  isSeaFcl
                    ? [
                        (v) => {
                          if (!v) {
                            return (
                              $t('app.labels.masterBlNo') +
                              $t('app.validator.messages.required')
                            );
                          } else if (!$legalInput(v)) {
                            return $t('app.validator.messages.illegalInput');
                          }
                        },
                      ]
                    : [
                        (v) =>
                          $legalInput(v) ||
                          $t('app.validator.messages.illegalInput'),
                      ]
                "
                clearable
                key="masterBlNo"
                v-model="sa.masterBlNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="!editable"
                :label="$t('app.labels.houseBlNo')"
                :rules="
                  !isSeaFcl
                    ? [
                        (v) => {
                          if (!v) {
                            return (
                              $t('app.labels.houseBlNo') +
                              $t('app.validator.messages.required')
                            );
                          } else if (!$legalInput(v)) {
                            return $t('app.validator.messages.illegalInput');
                          }
                        },
                      ]
                    : [
                        (v) =>
                          $legalInput(v) ||
                          $t('app.validator.messages.illegalInput'),
                      ]
                "
                clearable
                key="houseBlNo"
                v-model="sa.houseBlNo"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <!-- <date-picker
                :disabled="!editable"
                :label="$t('app.labels.shippingAdvice.requestDate')"
                :rules="rulesSwitch([v => !!v || $t('app.labels.shippingAdvice.requestDate') + $t('app.validator.messages.required')])"
                key="requestDate"
                v-model="sa.requestDate"
              />-->
              <date-input
                :disabled="!editable"
                :label="$t('app.labels.shippingAdvice.requestDate')"
                :preRules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.shippingAdvice.requestDate') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="requestDate"
                v-model="sa.requestDate"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <date-input
                :disabled="!editable"
                :label="$t('app.labels.shippingAdvice.blIssueDate')"
                :max="maxBlDate"
                :min="minBlDate"
                :nextRules="
                  rulesSwitch(
                    [
                      (v) =>
                        lessThanOrEqual(v, maxBlDate) || 'より大きいetd+10',
                      (v) =>
                        greaterThanOrEqual(v, minBlDate) || 'より小さいetd-10',
                    ],
                    true
                  )
                "
                :preRules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.shippingAdvice.blIssueDate') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="blIssueDate"
                v-model="sa.blIssueDate"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="!editable || hasSjlSend"
                :label="$t('app.labels.loadingPort')"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.loadingPort') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="loadingPortCode"
                url="ports/kv"
                v-model="sa.loadingPortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-input
                :disabled="!editable"
                :label="$t('app.labels.etd')"
                :max="maxEtd"
                :min="minEtd"
                :nextRules="
                  rulesSwitch(
                    [
                      (v) =>
                        lessThanOrEqual(v, maxEtd) || 'より大きいB/L発行日+10',
                      (v) =>
                        greaterThanOrEqual(v, minEtd) ||
                        'より小さいB/L発行日-10',
                    ],
                    true
                  )
                "
                :preRules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.etd') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="etd"
                v-model="sa.etd"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-input
                :disabled="!editable"
                :label="$t('app.labels.eta')"
                :min="minEta"
                :nextRules="
                  rulesSwitch(
                    [(v) => greaterThanOrEqual(v, minEta) || 'より小さいetd'],
                    true
                  )
                "
                :preRules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.eta') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="eta"
                v-model="sa.eta"
              />
            </v-flex>

            <v-flex md3>
              <remote-select
                :disabled="!editable || hasSjlSend"
                :label="$t('app.labels.transportMode')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.transportMode') +
                      $t('app.validator.messages.required'),
                ]"
                key="transportModeId"
                url="transport-modes/kv"
                v-model="sa.transportModeId"
              />
            </v-flex>

            <v-flex md3>
              <remote-autocomplete
                :disabled="true"
                label="建值"
                url="incoterms/kv/codes"
                v-model="sa.incotermId"
              />
            </v-flex>

            <v-flex key="stackTypeId" md3 v-if="isSea">
              <remote-select
                :disabled="!editable || hasSjlSend"
                :label="$t('app.labels.stackType')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.stackType') +
                      $t('app.validator.messages.required'),
                ]"
                key="stackTypeId"
                url="stack-types/kv"
                v-model="sa.stackTypeId"
              />
            </v-flex>

            <v-flex md3>
              <remote-autocomplete
                :disabled="!editable || hasSjlSend"
                :label="$t('app.labels.dischargePort')"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.dischargePort') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="dischargePortCode"
                url="ports/kv"
                v-model="sa.dischargePortCode"
              />
            </v-flex>

            <v-flex md3>
              <remote-autocomplete
                :disabled="!editable"
                :label="$t('app.labels.currency')"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.currency') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="currencyCode"
                url="currencies/kv"
                v-model="sa.currencyCode"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <date-input
                :disabled="!editable"
                :label="
                  $t('app.labels.shippingAdvice.exportCustomsClearanceDate')
                "
                :preRules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t(
                          'app.labels.shippingAdvice.exportCustomsClearanceDate'
                        ) + $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="exportCustomsClearanceDate"
                v-model="sa.exportCustomsClearanceDate"
              ></date-input>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="!editable && !hasSendMail"
                :label="$t('app.labels.forwarder')"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        $t('app.labels.forwarder') +
                          $t('app.validator.messages.required'),
                    ],
                    true
                  )
                "
                key="forwarderId"
                :url="forwarderUrl"
                v-model="sa.forwarderId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex key="shipName" md3 sm6 v-if="isSea" xs12>
              <v-text-field
                :disabled="!editable"
                :label="$t('app.labels.shipName')"
                :rules="
                  isSea
                    ? rulesSwitch(
                        [
                          (v) => {
                            if (!v) {
                              return (
                                $t('app.labels.shipName') +
                                $t('app.validator.messages.required')
                              );
                            } else if (!$legalInput(v)) {
                              return $t('app.validator.messages.illegalInput');
                            }
                          },
                        ],
                        true
                      )
                    : []
                "
                clearable
                key="shipName"
                v-model="sa.shipName"
              ></v-text-field>
            </v-flex>

            <v-flex key="volNo" md3 sm6 v-if="isAir" xs12>
              <v-text-field
                :disabled="!editable"
                :label="$t('B0400.labels.flightNo')"
                :rules="
                  isAir
                    ? rulesSwitch(
                        [
                          (v) => {
                            if (!v) {
                              return (
                                $t('B0400.labels.flightNo') +
                                $t('app.validator.messages.required')
                              );
                            } else if (!$legalInput(v)) {
                              return $t('app.validator.messages.illegalInput');
                            }
                          },
                        ],
                        true
                      )
                    : []
                "
                clearable
                key="flightNo"
                v-model="sa.volNo"
              ></v-text-field>
            </v-flex>

            <v-flex key="volNo" md3 sm6 v-if="isSea" xs12>
              <v-text-field
                :disabled="!editable"
                :label="$t('B0400.labels.voyageNo')"
                :rules="
                  isSea
                    ? rulesSwitch(
                        [
                          (v) => {
                            if (!v) {
                              return (
                                $t('B0400.labels.voyageNo') +
                                $t('app.validator.messages.required')
                              );
                            } else if (!$legalInput(v)) {
                              return $t('app.validator.messages.illegalInput');
                            }
                          },
                        ],
                        true
                      )
                    : []
                "
                clearable
                key="volNo"
                v-model="sa.volNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="!editable"
                :label="$t('B0400.labels.siNo')"
                :rules="
                  rulesSwitch(
                    [
                      (v) => {
                        if (!v) {
                          return (
                            $t('B0400.labels.siNo') +
                            $t('app.validator.messages.required')
                          );
                        } else if (!$legalInput(v)) {
                          return $t('app.validator.messages.illegalInput');
                        }
                      },
                    ],
                    false
                  )
                "
                clearable
                key="siNo"
                v-model="sa.siNo"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="!editable"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        '貨物タイプ' + $t('app.validator.messages.required'),
                    ],
                    false
                  )
                "
                key="commodityTypeId"
                label="貨物タイプ"
                url="commodity-types/kv"
                v-model="sa.commodityTypeId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12 v-if="isLcl">
              <remote-autocomplete
                :disabled="!editable"
                :filter="(p) => p.code !== 'WAREHOUSE_TRANSPORT'"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        'Special' + $t('app.validator.messages.required'),
                    ],
                    false
                  )
                "
                key="specialId"
                label="Special"
                url="specials/kv"
                v-model="sa.specialId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12 v-if="!isLcl">
              <remote-autocomplete
                :disabled="!editable"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        'Special' + $t('app.validator.messages.required'),

                      (v) => isSpecialLegal || '倉庫間転送選択不可',
                    ],
                    false
                  )
                "
                key="specialId"
                label="Special"
                url="specials/kv"
                v-model="sa.specialId"
              />
            </v-flex>

            <v-flex md3 sm6 v-if="isWarehouseTransport" xs12>
              <remote-autocomplete
                :disabled="!editable"
                :rules="
                  rulesSwitch(
                    [
                      (v) =>
                        !!v ||
                        '納入場所' + $t('app.validator.messages.required'),
                    ],
                    false
                  )
                "
                key="finallyWarehouseId"
                label="納入場所"
                url="warehouses/sjl-kv"
                v-model="sa.finallyWarehouseId"
              />
            </v-flex>
            <v-flex md3 sm6 v-if="isWarehouseTransport" xs12>
              <div>
                <date-input
                  :disabled="!editable"
                  :preRules="
                    rulesSwitch(
                      [
                        (v) =>
                          !!v ||
                          '納入予定日' + $t('app.validator.messages.required'),
                      ],
                      true
                    )
                  "
                  label="納入予定日"
                  v-model="sa.forecastDeliveryDate"
                ></date-input>
              </div>
            </v-flex>
            <v-flex md3 sm6 v-if="!isWarehouseTransport" xs12>
              <remote-autocomplete
                :disabled="(!editable && !hasSendMail) || isWarehouseTransport"
                :label="$t('app.labels.customsAgent')"
                :rules="
                  isWarehouseTransport
                    ? []
                    : rulesSwitch(
                        [
                          (v) =>
                            !!v ||
                            $t('app.labels.customsAgent') +
                              $t('app.validator.messages.required'),
                        ],
                        false
                      )
                "
                item-text="text"
                item-value="value"
                key="customsDirectorId"
                :url="customsUrl"
                v-model="sa.customsDirectorId"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card class="mt-2">
      <v-card-title primary-title style="padding-left: 8px">
        <span class="headline mb-0">{{ $t("B0400.titles[2]") }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="hasSjlSend || !editable" @click="addPackings">{{
          $t("app.buttons.add")
        }}</v-btn>
        <v-btn
          :disabled="selected.length == 0 || hasSjlSend || !editable"
          @click="removePackages"
          >INV削除</v-btn
        >
        <v-btn :disabled="hasSjlSend || !editable" @click="split">{{
          $t("app.buttons.split")
        }}</v-btn>
        <v-btn :disabled="hasSjlSend || !editable" @click="cancelSplit">{{
          $t("app.buttons.cancelSplit")
        }}</v-btn>
        <v-btn :disabled="hasSjlSend || !editable" @click="inputNGM"
          >I/V重量容積入力</v-btn
        >
        <!-- air not need contianer set. disabled="sa.transportModeId === 'TRANSPORT_MODE-AIR'" -->
        <v-btn
          :disabled="isAir || hasSjlSend || !editable"
          @click="updateContainerNoAndSize"
          >{{ $t("app.buttons.updateContainer") }}</v-btn
        >
        <table-upload
          :title="$t('app.buttons.csvUpload')"
          @input="packageUpload"
          v-if="!hasSjlSend && editable"
        />
        <v-btn @click="downloadPackages" v-permit.SHARP_SA_DOWNLOAD
          >Excel出力</v-btn
        >
        <v-spacer></v-spacer>
        <div style="display: flex">
          <div style="margin-right: 15px">
            <div class="statistic">
              <div class="label">コンテナ本数</div>
            </div>
            <div class="statistic">
              <div class="label">40HC : {{ fortyHC || 0 }}本</div>
            </div>
            <div class="statistic">
              <div class="label">40GP : {{ fortyGP || 0 }}本</div>
            </div>
            <div class="statistic">
              <div class="label">20GP : {{ twentyGP || 0 }}本</div>
            </div>
          </div>
          <div>
            <div class="statistic">
              <div class="label">{{ $t("app.labels.totalAmount") }}:</div>
              <div class="value">
                {{ total | currency({ symbol: "", fractionCount: 2 }) }}
              </div>
            </div>
            <div class="statistic">
              <div class="label">合計数量:</div>
              <div class="value">
                {{ totalQty | currency({ symbol: "", fractionCount: 0 }) }}
              </div>
            </div>
          </div>
          <div style="margin-left: 15px">
            <div class="statistic">
              <div class="label">合計N/W:</div>
              <div class="value">
                {{
                  totalNetWeight | currency({ symbol: "", fractionCount: 2 })
                }}
              </div>
            </div>
            <div class="statistic">
              <div class="label">合計G/W:</div>
              <div class="value">
                {{
                  totalGrossWeight | currency({ symbol: "", fractionCount: 2 })
                }}
              </div>
            </div>
            <div class="statistic">
              <div class="label">合計M3:</div>
              <div class="value">
                {{ totalM3 | currency({ symbol: "", fractionCount: 3 }) }}
              </div>
            </div>
          </div>
        </div>
      </v-card-actions>

      <v-data-table
        :headers="displayHeaders"
        :items="sa.packages"
        :rows-per-page-items="[50]"
        :select-all="true"
        class="inline-edit"
        item-key="seq"
        key="fcl"
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <v-checkbox hide-details primary v-model="props.selected" />
            </td>
            <td key="containerNo" v-if="isSeaFcl">
              <v-text-field
                :disabled="!editable || hasSjlSend"
                :placeholder="$t('app.labels.package.containerNo')"
                v-model="props.item.containerNo"
              />
            </td>
            <td key="containerTypeId" v-if="isSeaFcl">
              <remote-autocomplete
                :disabled="(!editable && !hasSendMail) || hasSjlSend"
                :placeholder="$t('app.labels.package.containerSize')"
                url="container-types/kv"
                v-model="props.item.containerTypeId"
              />
            </td>
            <td>{{ props.item.invoiceNo }}</td>
            <td>{{ props.item.skuCode }}</td>
            <td>{{ props.item.lotNo }}</td>
            <td>{{ props.item.poNo }}</td>
            <td>
              <v-text-field
                :disabled="!editable || hasSjlSend"
                :placeholder="$t('app.labels.package.totalQty')"
                @change="calQty(props.item)"
                class="input-number"
                type="number"
                v-model="props.item.totalQty"
              />
            </td>
            <td>
              <v-text-field
                :disabled="!editable || hasSjlSend"
                :placeholder="$t('app.labels.package.flag')"
                v-model="props.item.flag"
              />
            </td>
            <td>
              <v-text-field
                :disabled="!editable || hasSjlSend"
                @change="qtyChange(props.item)"
                type="number"
                v-model="props.item.cartonStartNo"
              />
            </td>
            <td>
              <v-text-field
                :disabled="!editable || hasSjlSend"
                @change="qtyChange(props.item)"
                type="number"
                v-model="props.item.cartonEndNo"
              />
            </td>
            <td>
              <v-text-field
                :disabled="true"
                :placeholder="$t('app.labels.package.shippedCarton')"
                type="number"
                v-model="props.item.shippedCarton"
              />
            </td>
            <td>
              <v-text-field
                :disabled="true"
                :placeholder="$t('app.labels.package.perCartonQty')"
                type="number"
                v-model="props.item.perCartonQty"
              />
            </td>
            <td>
              <v-text-field
                :disabled="!editable || hasSjlSend"
                @change="clearNum(props.item)"
                type="number"
                v-model="props.item.totalNetWeight"
              />
            </td>
            <td>
              <v-text-field
                :disabled="!editable || hasSjlSend"
                @change="clearNum(props.item)"
                type="number"
                v-model="props.item.totalGrossWeight"
              />
            </td>
            <td>
              <v-text-field
                :disabled="!editable || hasSjlSend"
                @change="clearNum(props.item)"
                type="number"
                v-model="props.item.totalVolume"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <edit-container-dialog ref="editContainerDlg" />
    <search-invoice-dialog :sa="sa" ref="searchInvoiceDlg" />
    <upload-file-dialog
      :blNo="isSeaFcl ? sa.masterBlNo : sa.houseBlNo"
      ref="uploadFileDialog"
    />
    <e-t-a-update-dialog :sa="sa" ref="etaUpdateDialog"></e-t-a-update-dialog>
    <invoice-input ref="invoiceInput"></invoice-input>
    <message-alert ref="message"></message-alert>
    <archive-cancel-dialog
      ref="archiveCancelDialog"
      :shipmentType="sa.shipmentType"
    />
    <update-container-no
      @refresh="load"
      :sourceContainerNo="selected.length > 0 && selected[0].containerNo"
      :deliveryOrder="sa"
      ref="updateContainerNo"
    ></update-container-no>
  </v-container>
</template>

<script>
import EditContainerDialog from "./EditContainerDialog";
import SearchInvoiceDialog from "./SearchInvoiceDialog";
import ETAUpdateDialog from "./ETAUpdateDialog";
import UploadFileDialog from "./UploadFileDialog";
import ArchiveCancelDialog from "./ArchiveCancelDialog";
import InvoiceInput from "./InvoiceInput";
import { calQty } from "../../func/B0401";
import UpdateContainerNo from "../B0700/UpdateContainerNo.vue";

export default {
  data() {
    return {
      standardNGV: [],
      required: false,
      transportMode: "",
      valid: false,
      invoices: [],
      sa: {
        shipmentType: "SA",
        packages: [],
        stackTypeId: null,
        transportModeId: null,
      },
      selected: [],
      pagination: {},
      errors: {
        SHIPMENT_HAS_CHANGED:
          "当該データのステータスは更新されたため、画面更新してからもう一度お試してください。",
        INVALID_SA_STATUS: this.$t("B0400.messages.errors.sa_status_invalid"), //'S/A取消してください。',
        PACKAGE_QTY_OVER: this.$t("B0400.messages.errors.package_qty_over"), //'既存の数量を越えてしまいました。',
        INVALID_INV_STATUS: this.$t("B0400.messages.errors.inv_canceled"), //'I/V取消してください',
        INVALID_STATUS: this.$t("B0400.messages.errors.do_not_relieve"), //'DO未解除或DO解除未确认',
        BL_NO_DUPLICATE: this.$t("B0400.messages.errors.invalidBlNo"),
        PAY_SITE_NOT_UNIQUE: this.$t("B0400.messages.errors.paysit_not_unique"), //'different pay date',
        ALL_UNPAID_PACKAGES: this.$t("B0400.messages.errors.pay_inv_require"), //'有償INVが無いと、SAを作成できません。',
        DIFFERENT_SOURCE_INVOICE: this.$t(
          "B0400.messages.errors.source_conflict"
        ),
        //'different source invoice can not mix into one shipment'
        CAN_NOT_TURN_BACK:
          "ステータスは「DO確定済」、或いは「DO解除承認待ち」ですので、該当SAが一時保存へ戻せない、戻りたい場合、DO解除してDO確定の流れで進めてください",
        NO_SJL_DIRECTOR:
          "該当Shipper・事業本部のSJL担当者情報が登録していませんので、SA登録できません。",
        CANCEL_WITH_NO_DONO: "DO.NOがまだ取れないため、取消ができません。",
        DATA_FROZEN_CANCEL: "データが凍結されたので、SA取消ができません。",
        DATA_FROZEN_BACK:
          "データが凍結されたので、SA一時保存戻すができません。",
        EMPTY_CONTAINER_NO: "INV P/L情報が不整備です、ご確認お願いします。",
        EXCHANGE_RATE_NOT_FOUND: this.$t("B0800.messages.exchangeRateNotFound"),
        UNPAID_INVOICE: "无偿invoice不可上传",
        DO_HAS_CONFIRMED: this.$t("B1000.messages.errors.doHasConfirmed"),
        DATA_FROZEN: "該当諸掛費用が凍結されたため、SA変更不可",
        CONTAINER_NO_SIZE_NOT_UNIQUE: this.$t(
          "B0400.messages.errors.ctn_no_save_type_diff"
        ),
      },
      headers: [
        {
          text: this.$t("app.labels.package.containerNo"),
          value: "containerNo",
          sortable: true,
        },
        {
          text: this.$t("app.labels.package.containerSize"),
          value: "containerSize",
          sortable: false,
        },
        {
          text: this.$t("app.labels.ivNo"),
          value: "invoiceNo",
        },
        {
          text: this.$t("app.labels.skuCode"),
          value: "skuCode",
          sortable: false,
        },
        {
          text: this.$t("app.labels.lotNo"),
          value: "lotNo",
        },
        {
          text: this.$t("app.labels.poNo"),
          value: "poNo",
        },
        {
          text: this.$t("app.labels.package.totalQty"),
          value: "totalQty",
          sortable: false,
        },
        {
          text: this.$t("app.labels.package.flag"),
          value: "flag",
          sortable: false,
        },
        {
          text: this.$t("app.labels.package.cartonStartNo"),
          value: "cartonStartNo",
          sortable: true,
        },
        {
          text: this.$t("app.labels.package.cartonEndNo"),
          value: "cartonEndNo",
          sortable: false,
        },
        {
          text: this.$t("app.labels.package.shippedCarton"),
          value: "shippedCarton",
          sortable: false,
        },
        {
          text: this.$t("app.labels.package.perCartonQty"),
          value: "perCartonQty",
          sortable: false,
        },
        {
          text: "N/W",
          value: "totalNetWeight",
          sortable: false,
        },
        {
          text: "G/W",
          value: "totalGrossWeight",
          sortable: false,
        },
        {
          text: "M3",
          value: "totalVolume",
          sortable: false,
        },
      ],
    };
  },
  components: {
    InvoiceInput,
    EditContainerDialog,
    SearchInvoiceDialog,
    ETAUpdateDialog,
    UploadFileDialog,
    ArchiveCancelDialog,
    UpdateContainerNo,
  },
  computed: {
    forwarderUrl() {
      return this.sa.hasAnyChildConfirmed
        ? "companies/kv-include-all"
        : "companies/forwarders/kv";
    },
    customsUrl() {
      return this.sa.hasAnyChildConfirmed
        ? "companies/kv-include-all"
        : "companies/customs/kv";
    },
    twentyGP() {
      return this.getContainerCount("CONTAINER_TYPE-20F");
    },
    fortyGP() {
      return this.getContainerCount("CONTAINER_TYPE-40F");
    },
    fortyHC() {
      return this.getContainerCount("CONTAINER_TYPE-40FHQ");
    },
    //"CONTAINER_TYPE-40FHQ"
    canDeleteInvoice() {
      return (
        this.sa.shipmentType === "FORMALSA" &&
        this.selected.filter((s) => s.invoiceType === "FORMALSA").length === 0
      );
    },
    isSytc() {
      var user = this.$store.getters.user;
      return (
        user.roles.map((r) => r.roleCode).filter((r) => "ROLE_PARTNER" === r)
          .length > 0 &&
        "57c86826-86ce-4269-a728-0cf1c85ed8ff" === this.sa.partnerId
      );
    },
    isWarehouseTransport() {
      return (
        this.isAllPackageUnpaid &&
        this.sa.specialId &&
        this.sa.specialId.indexOf("WAREHOUSE_TRANSPORT") !== -1
      );
    },
    isAllPackageUnpaid() {
      return (
        (this.isAir || this.isSeaFcl) &&
        (this.sa.isAllUnpaid ||
          this.sa.packages.filter((p) => p.poNo === null || p.poNo === "")
            .length == this.sa.packages.length) &&
        this.sa.packages.length > 0
      );
    },

    isSpecialLegal() {
      if (this.isAllPackageUnpaid) {
        return true;
      }
      return (
        this.sa.specialId &&
        this.sa.specialId.indexOf("WAREHOUSE_TRANSPORT") === -1
      );
    },

    hasSjlSend() {
      return (
        this.sa.shipmentType === "PARTNERSA" &&
        (this.sa.hasBlSend || this.sa.status === "指示Mail送信済") &&
        this.sa.status !== "SA一時保存-SJL"
      );
    },
    total() {
      return this.sa.packages
        .filter((i) => i.totalQty != null && i.unitPrice != null)
        .reduce((t, i) => t + this.subTotal(i), 0);
    },
    totalQty() {
      return this.sa.packages
        .filter((i) => i.totalQty != null)
        .reduce((t, i) => t + i.totalQty, 0);
    },

    totalNetWeight() {
      return this.sa.packages
        .filter((i) => i.totalNetWeight != null)
        .reduce((t, i) => t + Number(i.totalNetWeight), 0);
    },
    totalGrossWeight() {
      return this.sa.packages
        .filter((i) => i.totalGrossWeight != null)
        .reduce((t, i) => t + Number(i.totalGrossWeight), 0);
    },
    totalM3() {
      return this.sa.packages
        .filter((i) => i.totalVolume != null)
        .reduce((t, i) => t + Number(i.totalVolume), 0);
    },

    canCancel() {
      return this.isSa || this.isPreSa || this.isPartnerSa;
    },
    canBlTurnBack() {
      return (
        (this.sa.shipmentType === "PRESA" ||
          this.sa.shipmentType === "FORMALSA") &&
        this.sa.blNo &&
        this.sa.status != "SA一時保存"
      );
    },
    isSa() {
      return this.sa.shipmentType === "SA";
    },
    isPartnerSa() {
      return this.sa.shipmentType === "PARTNERSA";
    },
    isPreSa() {
      return this.sa.shipmentType === "FORMALSA" && this.sa.source === "SYS";
    },
    isFormalSa() {
      return this.sa.shipmentType === "FORMALSA" && this.sa.source === "IF";
    },
    displayHeaders() {
      return this.headers.filter(
        (h) =>
          this.isSeaFcl || "containerNo,containerSize".indexOf(h.value) === -1
      );
    },
    sameContainerNoDifType() {
      if (this.sa.stackTypeId === "STACK_TYPE-FCL") {
        var containerNos = this.sa.packages
          .map((p) => p.containerNo)
          .reduce((total, containerNo) => {
            if (total.indexOf(containerNo) == -1) {
              total.push(containerNo);
            }
            return total;
          }, []);
        for (var i = 0; i < containerNos.length; i++) {
          var containerTypes = this.sa.packages
            .filter((p) => p.containerNo === containerNos[i])
            .map((p) => p.containerTypeId)
            .reduce((total, containerTypeId) => {
              if (total.indexOf(containerTypeId) == -1) {
                total.push(containerTypeId);
              }
              return total;
            }, []);
          if (containerTypes.length > 1) {
            return containerNos[i];
          }
        }
      }
      return false;
    },
    canEdit() {
      return this.sa.status == "SA一時保存";
    },
    minEta() {
      if (!this.sa.etd) return null;
      return new Date(this.sa.etd).format("yyyyMMdd");
    },
    maxBlDate() {
      if (!this.sa.etd) return null;
      var date = new Date(this.sa.etd);
      date.setDate(date.getDate() + 10);
      return date.format("yyyyMMdd");
    },
    minBlDate() {
      if (!this.sa.etd) return null;
      var date = new Date(this.sa.etd);
      date.setDate(date.getDate() - 10);
      return date.format("yyyyMMdd");
    },
    maxEtd() {
      if (!this.sa.blIssueDate) {
        if (!this.sa.eta) {
          return null;
        } else {
          return new Date(this.sa.eta).format("yyyyMMdd");
        }
      }
      var date = new Date(this.sa.blIssueDate);
      date.setDate(date.getDate() + 10);
      return date.format("yyyyMMdd");
    },
    minEtd() {
      if (!this.sa.blIssueDate) return null;
      var date = new Date(this.sa.blIssueDate);
      date.setDate(date.getDate() - 10);
      return date.format("yyyyMMdd");
    },
    isSeaFcl() {
      return this.isSea && this.isFcl;
    },
    isSea() {
      return this.$isSea(this.sa.transportModeId);
    },
    isAir() {
      return this.$isAir(this.sa.transportModeId);
    },
    isFcl() {
      return this.sa.stackTypeId == "STACK_TYPE-FCL";
    },
    isLcl() {
      return this.sa.stackTypeId == "STACK_TYPE-LCL";
    },
    canUpload() {
      return (
        (this.isSeaFcl && this.sa.masterBlNo) ||
        (!this.isSeaFcl && this.sa.houseBlNo)
      );
    },
    hasSendMail() {
      return (
        this.sa.status === "SA登録済" || this.sa.status === "指示Mail送信済"
      );
    },
    editable() {
      var user = this.$store.getters.user;
      if (
        user.roles.map((r) => r.roleCode).filter((r) => "ROLE_PARTNER" === r)
          .length > 0
      ) {
        return this.sa.status == "SA一時保存" ||
          this.sa.status == null ||
          this.sa.status === "SA一時保存-海"
          ? true
          : false;
      } else {
        if (this.sa.shipmentType === "PARTNERSA") {
          return true;
        }
        return this.sa.status == "SA一時保存" ||
          this.sa.status == null ||
          this.sa.status === "SA一時保存-海" ||
          this.sa.status === "SA一時保存-SJL" ||
          this.sa.status === "SJL送信済"
          ? true
          : false;
      }
    },
    canSjlSend() {
      return (
        this.sa.blIssueDate &&
        this.sa.requestDate &&
        this.sa.eta &&
        this.sa.etd &&
        this.sa.loadingPortCode &&
        this.sa.dischargePortCode &&
        this.sa.exportCustomsClearanceDate &&
        this.sa.currencyCode &&
        this.sa.forwarderId &&
        this.sa.volNo &&
        this.sa.stackTypeId &&
        this.sa.transportModeId &&
        ((this.isSea && !this.sa.shipName) || this.isAir) &&
        (this.isAir || this.isLcl) &&
        this.sa.houseBlNo
      );
    },
  },
  methods: {
    updateContainerNo() {
      this.$refs.updateContainerNo.popup();
    },
    getContainerCount(type) {
      var containerNos = [];
      this.sa.packages
        .filter((pkg) => pkg.containerTypeId === type)
        .forEach((pkg) => {
          if (containerNos.indexOf(pkg.containerNo) < 0) {
            containerNos.push(pkg.containerNo);
          }
        });
      return containerNos.length;
    },
    empty(v) {
      return v == null || v == "";
    },
    lessThanOrEqual(a, b) {
      if (this.empty(a) || this.empty(b)) {
        return true;
      }
      return a.localeCompare(b) <= 0;
    },

    greaterThanOrEqual(a, b) {
      console.log(a);
      console.log(b);
      if (this.empty(a) || this.empty(b)) {
        return true;
      }
      return a.localeCompare(b) >= 0;
    },
    clearNum(item) {
      if (item.totalNetWeight)
        item.totalNetWeight = this.$numberScale2(item.totalNetWeight);
      if (item.totalGrossWeight)
        item.totalGrossWeight = this.$numberScale2(item.totalGrossWeight);
      if (item.totalVolume)
        item.totalVolume = this.$numberScale3(item.totalVolume);
      this.initNGVData();
    },
    initNGVData() {
      var pkgs = this.sa.packages;
      pkgs.forEach((pkg) => {
        //只有一个的时候才赋标准
        if (pkgs.filter((p) => p.poNo === pkg.poNo).length === 1) {
          var data = this.standardNGV.find((s) => s.poNo === pkg.poNo);

          if (!data) {
            //创建标准
            this.standardNGV.push({
              poNo: pkg.poNo,
              totalNetWeight: pkg.totalNetWeight,
              totalGrossWeight: pkg.totalGrossWeight,
              totalVolume: pkg.totalVolume,
              totalQty: pkg.totalQty,
            });
          } else {
            //更新标准
            data.poNo = pkg.poNo;
            data.totalNetWeight = pkg.totalNetWeight;
            data.totalGrossWeight = pkg.totalGrossWeight;
            data.totalVolume = pkg.totalVolume;
            data.totalQty = pkg.totalQty;
          }
        }
      });
    },
    qtyChange(item) {
      calQty(item);
      this.$forceUpdate();
      this.calNewNGV(item);
    },
    calNewNGV(item) {
      var standard = this.standardNGV.find((s) => s.poNo === item.poNo);

      var percent =
        Math.round(item.totalQty * 1000000) / 1000000 / standard.totalQty;

      item.totalNetWeight =
        Math.round(percent * standard.totalNetWeight * 100) / 100;

      item.totalGrossWeight =
        Math.round(percent * standard.totalGrossWeight * 100) / 100;

      item.totalVolume =
        Math.round(percent * standard.totalVolume * 1000) / 1000;

      this.checkNGV();
    },
    checkNGV() {
      this.standardNGV.forEach((standard) => {
        var totalGrossWeight = this.sa.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalGrossWeight;
          }, 0);
        var totalNetWeight = this.sa.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalNetWeight;
          }, 0);
        var totalVolume = this.sa.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalVolume;
          }, 0);

        var totalQty = this.sa.packages
          .filter((p) => p.poNo === standard.poNo)
          .reduce((t, p) => {
            return t + p.totalQty;
          }, 0);

        if (Number(totalQty) === Number(standard.totalQty)) {
          var firstPkg = this.sa.packages.find((p) => p.poNo === standard.poNo);
          if (Number(standard.totalGrossWeight) !== Number(totalGrossWeight)) {
            console.log("total gross weight not equal");
            firstPkg.totalGrossWeight =
              Math.round(
                (firstPkg.totalGrossWeight +
                  Number(standard.totalGrossWeight) -
                  Number(totalGrossWeight)) *
                  100
              ) / 100;
          }
          if (Number(standard.totalNetWeight) !== Number(totalNetWeight)) {
            console.log("total net weight not equal");
            firstPkg.totalNetWeight =
              Math.round(
                (firstPkg.totalNetWeight +
                  Number(standard.totalNetWeight) -
                  Number(totalNetWeight)) *
                  100
              ) / 100;
          }
          if (Number(standard.totalVolume) !== Number(totalVolume)) {
            console.log("total volume not equal");
            firstPkg.totalVolume =
              Math.round(
                (firstPkg.totalVolume +
                  Number(standard.totalVolume) -
                  Number(totalVolume)) *
                  1000
              ) / 1000;
          }
        }
      });
    },
    NGMSubTotal(item) {
      return Math.round(item.unitPrice * item.totalQty * 1000000) / 1000000;
    },
    calNGM(data) {
      data.forEach((d) => {
        var packages = this.sa.packages.filter(
          (pkg) => pkg.invoiceNo === d.invoiceNo
        );
        var total = packages
          .filter((i) => i.totalQty != null && i.unitPrice != null)
          .reduce((t, i) => t + this.NGMSubTotal(i), 0);
        console.log("total" + total);
        packages.forEach((p) => {
          var percent =
            Math.round(p.unitPrice * p.totalQty * 1000000) / 1000000 / total;
          if (Math.round(percent * d.nw * 100) / 100 === 0) {
            p.totalNetWeight = 0.01;
          } else {
            p.totalNetWeight = Math.round(percent * d.nw * 100) / 100;
          }
          if (Math.round(percent * d.gw * 100) / 100 === 0) {
            p.totalGrossWeight = 0.01;
          } else {
            p.totalGrossWeight = Math.round(percent * d.gw * 100) / 100;
          }

          if (Math.round(percent * d.m3 * 1000) / 1000 === 0) {
            p.totalVolume = 0.001;
          } else {
            p.totalVolume = Math.round(percent * d.m3 * 1000) / 1000;
          }
        });
        this.$forceUpdate();
      });
    },
    inputNGM() {
      var invoiceNo = this.sa.packages
        .map((p) => p.invoiceNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b);
          }
          return a;
        }, []);
      this.$refs.invoiceInput.popup(invoiceNo).then((data) => {
        console.log(data);
        this.calNGM(data);
        this.initNGVData();
      });
    },
    subTotal(item) {
      return Math.round(item.unitPrice * item.totalQty * 100) / 100;
    },
    cartonQty(pkg) {
      return pkg.cartonEndNo - pkg.cartonStartNo + 1;
    },
    downloadPackages() {
      var showHeaders = [
        "海外取引先Code",
        "CONTAINER SIZE(20F,40F, 40FHQ)",
        "CONTAINER No.",
        "INVOICE No.",
        "S/I No.",
        "MODEL",
        "LOT No. ",
        "QTY",
        "Case Identity No.",
        "Start Carton No.",
        "End Carton No.",
        "SHIPPED CARTONS",
        "QTY PER CARTON",
        "N/W",
        "G/W",
        "M3",
        "COUNTRY OF ORIGIN",
        "UNIT PRICE",
      ];
      var headers = [
        "partnerCode",
        "containerTypeCode",
        "containerNo",
        "invoiceNo",
        "poNo",
        "skuCode",
        "lotNo",
        "totalQty",
        "flag",
        "cartonStartNo",
        "cartonEndNo",
        "shippedCarton",
        "perCartonQty",
        "totalNetWeight",
        "totalGrossWeight",
        "totalVolume",
        "originCountryName",
        "unitPrice",
      ];

      var packages = this.sa.packages.map((pkg) => {
        return {
          ...pkg,
          partnerCode: this.sa.partnerCode,
        };
      });
      this.$exportTable(packages, headers, showHeaders, "shipment-packages");
    },
    rulesSwitch(validation, sjlValidation) {
      if (this.required === "formal") {
        return validation;
      } else if (this.required === "temporary") {
        return [];
      } else if (this.required === "sjl") {
        if (sjlValidation) {
          return validation;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },

    cancelArchivedSa() {
      this.$http
        .put(`shipping-advices/${this.sa.id}/archive-cancel-apply`)
        .then(() => {
          if (this.canCancel) {
            this.$message("", "凍結後SA取消申請済み");
          } else if (this.canBlTurnBack) {
            this.$message("", "凍結後SA一時保存戻し申請済み");
          }
          this.load();
        })
        .catch((res) => this.showError(res));
    },

    cancelSa() {
      this.$confirm({
        content: "該当SAを取消して宜しいでしょうか？",
      }).then(() => {
        this.$http
          .put(
            `shipping-advices/${this.sa.id}/cancel?version=${this.sa.version}`
          )
          .then(() => {
            this.$message("", this.$t("B0400.messages.success.cancel_success")); //'取消が完了しました。'
            this.$router.push("/B0400");
          })
          .catch((res) => this.showError(res));
      });
    },
    formalSave() {
      this.setRequiredAndNextTick("formal", () => {
        this.$confirm({
          content: "データを保存してよろしいでしょうか?",
        }).then(() => {
          if (!this.validData()) return;
          else {
            if (this.$refs.form.validate()) {
              this.changeBlNo();
              this.$http
                .get(`shipping-advices/canceled?id=${this.sa.id}`)
                .then(() => {
                  this.$confirm({
                    content: "履歴操作を続き利用しましょうか？",
                  })
                    .then(() => {
                      this.$http
                        .post(`shipping-advices/${this.sa.id}/confirm`, {
                          ...this.sa,
                          sendMail: true,
                          copyHistory: true,
                        })
                        .then(() => {
                          this.load();
                          this.$forceUpdate();
                          this.$message(
                            "",
                            this.$t("app.messages.saveSuccess")
                          ); //'保存成功'
                        })
                        .catch((res) => {
                          this.showError(res);
                        });
                    })
                    .catch(() => {
                      this.$http
                        .put("shipping-advices/formal-save", this.sa)
                        .then(() => {
                          this.load();
                          this.$forceUpdate();
                          this.$message(
                            "",
                            this.$t("app.messages.saveSuccess")
                          ); //'保存成功'
                        })
                        .catch((res) => {
                          this.showError(res);
                        });
                    });
                })
                .catch(() => {
                  this.$http
                    .put("shipping-advices/formal-save", this.sa)
                    .then(() => {
                      this.load();
                      this.$forceUpdate();
                      this.$message("", this.$t("app.messages.saveSuccess")); //'保存成功'
                    })
                    .catch((res) => {
                      this.showError(res);
                    });
                });
            }
          }
        });
      });
    },
    // calQty(item) {
    //   if (
    //     item.cartonStartNo != null &&
    //     item.cartonEndNo != null &&
    //     item.perCartonQty != null
    //   ) {
    //     if (item.cartonEndNo - item.cartonStartNo + 1 != 0) {
    //       // item.perCartonQty = this.perCarton(item)
    //       item.shippedCarton = item.cartonEndNo - item.cartonStartNo + 1
    //       item.totalQty = item.shippedCarton * item.perCartonQty
    //     }
    //   }
    //   this.$forceUpdate()
    // },
    perCarton(item) {
      return item.totalQty / (item.cartonEndNo - item.cartonStartNo + 1);
    },
    portVaild(item) {
      if (!this.sameLoadingPort(item) || !this.sameDischargePort(item)) {
        return false;
      } else {
        if (
          this.sa.dischargePortCode == null &&
          this.sa.loadingPortCode == null
        ) {
          this.sa.dischargePortCode = item[0].dischargePortCode;
          this.sa.loadingPortCode = item[0].loadingPortCode;
          return true;
        } else {
          for (var i = 0; i < item.length; i++) {
            if (
              this.sa.dischargePortCode == item[i].dischargePortCode &&
              this.sa.loadingPortCode == item[i].loadingPortCode
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    },
    invoiceValid(item) {
      return this.sa.packages.filter((p) => {
        return item.find((i) => p.invoiceNo === i.invoiceNo);
      });
    },
    sameLoadingPort(item) {
      var a = item
        .filter((p) => p.loadingPortCode != null)
        .map((p) => p.loadingPortCode)
        .reduce((total, code) => {
          if (total.indexOf(code) == -1) {
            total.push(code);
          }
          return total;
        }, []);
      if (a.length > 1) {
        return false;
      } else {
        return true;
      }
    },
    sameDischargePort(item) {
      var a = item
        .filter((p) => p.dischargePortCode != null)
        .map((p) => p.dischargePortCode)
        .reduce((total, code) => {
          if (total.indexOf(code) == -1) {
            total.push(code);
          }
          return total;
        }, []);
      if (a.length > 1) {
        return false;
      } else {
        return true;
      }
    },
    openEta() {
      this.$http
        .get(`/shipping-advices/${this.sa.id}/canEta`)
        .then((res) => {
          if (res.data) {
            this.$refs.etaUpdateDialog.popup();
          } else {
            this.$message("", this.$t("B0400.messages.errors.do_confirmed")); //'sa已经do确认'
          }
        })
        .catch((err) => this.$catch(err));
    },
    goBack() {
      this.$router.push({
        path: "/B0400",
      });
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.sa.packages.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    setRequired(value) {
      this.required = value;
    },
    setRequiredAndNextTick(value, func) {
      this.setRequired(value);
      this.$nextTick(func);
    },
    validInvoiceInput(newInvoices) {
      console.log("newInvoices", newInvoices);

      if (this.distinctProp(newInvoices, "companyId")) {
        this.showInvInfoErr("バイヤー会社");
        return false;
      }

      if (this.distinctProp(newInvoices, "partnerId")) {
        this.showInvInfoErr("海外取引先");
        return false;
      }

      if (this.distinctProp(newInvoices, "transportModeId")) {
        this.showInvInfoErr("輸送形態");
        return false;
      }

      if (this.distinctProp(newInvoices, "currencyCode")) {
        this.showInvInfoErr("通貨");
        return false;
      }

      if (this.distinctProp(newInvoices, "incotermId")) {
        this.showInvInfoErr("建値");
        return false;
      }
      console.log("pass first check");
      var companyIdEq = this.propsEq("companyId", "companyId", newInvoices);
      console.log(companyIdEq);
      var partnerIdEq = this.propsEq("partnerId", "partnerId", newInvoices);
      console.log(partnerIdEq);
      var transportModeIdEq = this.propsEq(
        "transportModeId",
        "transportModeId",
        newInvoices
      );
      console.log(transportModeIdEq);
      var currencyEq = this.propsEq(
        "currencyCode",
        "currencyCode",
        newInvoices
      );
      console.log(currencyEq);
      var existIncotermIds = this.sa.packages.map((pkg) => pkg.incotermId);
      var incotermEq = true;
      if (existIncotermIds.length > 0) {
        for (var i = 0; i < newInvoices.length; i++) {
          if (existIncotermIds[0] !== newInvoices[i].incotermId) {
            incotermEq = false;
          }
        }
      }
      console.log(incotermEq);

      // console.log(incotermEq)
      // if (!partnerIdEq || !transportModeIdEq || !currencyEq || !incotermEq) {
      //   return false
      // }

      if (!companyIdEq) {
        this.showInvInfoErr("企業名称");
        return false;
      }

      if (!partnerIdEq) {
        this.showInvInfoErr("海外取引先");
        return false;
      }

      if (!transportModeIdEq) {
        this.showInvInfoErr("輸送形態");
        return false;
      }

      if (!currencyEq) {
        this.showInvInfoErr("通貨");
        return false;
      }

      if (!incotermEq) {
        this.showInvInfoErr("建値");
        return false;
      }

      return true;
    },

    showInvInfoErr(name) {
      this.$message(
        this.$t("app.messages.errors.title"),
        "当該インボイスの" +
          name +
          "がBLの運送情報と異なっているため、追加できません。"
      );
    },
    propsEq(saProp, invProp, newInvoices) {
      for (var i = 0; i < newInvoices.length; i++) {
        if (!!this.sa[saProp] && this.sa[saProp] !== newInvoices[i][invProp]) {
          return false;
        }
      }
      return true;
    },
    distinctProp(newInvoices, prop) {
      var total = newInvoices
        .filter((i) => !!i[prop])
        .map((i) => i[prop])
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i);
          }
          return t;
        }, []);
      return total.length > 1;
    },
    send() {
      this.setRequiredAndNextTick("formal", () => {
        if (!this.validData()) return;
        if (!this.$refs.form.validate()) return;
        if (this.sa.packages && this.sa.packages.length > 0) {
          //修改放在SA送信的时候再存一次用以更新SA发行数数据
          this.$confirm({
            content: this.$t("app.messages.sendConfirm"),
          }).then(() => {
            this.changeBlNo();
            this.$http
              .put(`shipping-advices/${this.$route.query.id}`, this.sa)
              .then(() => {
                return this.$http.get(`/shipping-advices/${this.sa.id}`);
              })
              .then((res) => {
                return this.$http.put(
                  `shipping-advices/${this.sa.id}/shipping-advice-send?version=${res.data.version}`
                );
              })
              .then(() => {
                this.$message(
                  this.$t("app.messages.success.title"),
                  this.$t("B0400.messages.success.sendSuccess")
                );
                this.load();
              })
              .catch((res) => this.showError(res));
          });
        } else {
          this.$message("", this.$t("B0400.messages.errors.package_required")); //'please add packages'
        }
      });
    },
    addPackings() {
      this.$refs.searchInvoiceDlg.popup().then((selected) => {
        if (!this.portVaild(selected)) {
          console.log(this.portVaild(selected));
          this.$message(
            this.$t("app.messages.errors.title"),
            this.$t("B0400.messages.errors.invalidPort")
          );
        } else if (this.invoiceValid(selected).length > 0) {
          this.$message(
            this.$t("app.messages.errors.title"),
            this.$t("B0400.messages.errors.invalidInvoice")
          );
        } else if (!this.validInvoiceInput(selected)) {
          return;
        } else {
          var packages = [];
          selected.forEach((s) => {
            packages = [...packages, ...s.packages];
          });

          this.sa.packages = [
            ...this.sa.packages,
            ...packages.map((s, index) => ({
              ...s,
              id: null,
              seq: new Date().getTime() + index,
              shippedCarton: s.cartonEndNo - s.cartonStartNo + 1,
            })),
          ];

          if (selected[0]) {
            var first = selected[0];
            this.sa = {
              ...this.sa,
              companyId: first.companyId,
              partnerId: first.partnerId,
              etd: this.sa.etd || first.etd,
              transportModeId: this.sa.transportModeId || first.transportModeId,
              currencyCode: this.sa.currencyCode || first.currencyCode,
              siNo: this.sa.siNo || first.siNo,
            };
          }
          this.initNGVData();
        }
      });
    },
    turnBack() {},
    showError(res) {
      var errorData = res.response.data.message.split(",");
      var poNos = [];
      for (var i = 1; i < errorData.length; i++) {
        poNos.push(errorData[i]);
      }
      if (this.errors[errorData[0]]) {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.errors[errorData[0]] + "poNo:" + poNos
        );
      } else if (this.errors[res.response.data.message]) {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.errors[res.response.data.message]
        );
      } else {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.$t("app.system.error")
        ); //'System Error.'
      }
    },
    removePackages() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        let invoiceIds = [...new Set(this.selected.map((s) => s.invoiceId))];
        this.sa.packages = this.sa.packages.filter(
          (p) => !invoiceIds.includes(p.invoiceId)
        );

        if (this.sa.packages.length === 0) {
          this.sa.loadingPortCode = null;
          this.sa.dischargePortCode = null;
        }

        this.selected = [];
        this.$message("", this.$t("app.messages.removeSuccess"));
      });
    },
    split() {
      this.sa.packages = this.sa.packages
        .reduce((t, p) => {
          t.push(p);
          if (this.selected.indexOf(p) !== -1) {
            t.push({
              ...p,
              id: null,
              issplit: true,
              totalNetWeight: 0,
              totalGrossWeight: 0,
              totalVolume: 0,
            });
          }
          return t;
        }, [])
        .map((p, idx) => ({
          ...p,
          seq: idx,
        }));

      this.selected = [];
    },
    cancelSplit() {
      // 把分拆的都取消
      // 然后重新加载一下
      var invoiceNos = this.sa.packages
        .map((p) => p.invoiceNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b);
          }
          return a;
        }, [])
        .join(",");

      console.log(invoiceNos);
      this.sa.packages = [];

      this.$http
        .get(`/commercial-invoices/get-invoice/${invoiceNos}`)
        .then((res) => {
          res.data.forEach((inv) => {
            this.sa.packages = [...this.sa.packages, ...inv.packages];
          });
          this.sa.packages.forEach((p, index) => {
            p.shippedCarton = p.cartonEndNo - p.cartonStartNo + 1;
            p.seq = new Date().getTime() + index * 1000;
          });
          console.log(res.data);
        });
      this.selected = [];
    },
    updateContainerNoAndSize() {
      this.$refs.editContainerDlg.popup().then((res) => {
        this.selected.forEach((s) => {
          this.$set(s, "containerNo", res.containerNo);
          this.$set(s, "containerTypeId", res.containerTypeId);
        });
        this.selected = [];
      });
    },
    changeBlNo() {
      if (this.sa.masterBlNo) {
        this.sa.masterBlNo = this.sa.masterBlNo.trim();
      }
      if (this.sa.houseBlNo) {
        this.sa.houseBlNo = this.sa.houseBlNo.trim();
      }
      this.sa.blNo = this.isSeaFcl ? this.sa.masterBlNo : this.sa.houseBlNo;
    },
    save() {
      this.setRequiredAndNextTick("temporary", () => {
        if (!this.$refs.form.validate()) return;
        this.changeBlNo();
        if (this.M3BiggerThan100()) {
          this.$message("", this.$t("B0400.messages.errors.m3_more_than_100"));
          return;
        }
        this.sa.packages.forEach((p, index) => {
          p.seq = new Date().getTime() + index;
        });
        this.$http
          .post("shipping-advices?view=B0401", this.sa)
          .then((res) => {
            this.edit(res.data.id);
            this.load();
          })
          .catch((res) => {
            this.showError(res);
          });
      });
    },
    edit(id) {
      this.$message("", this.$t("B0400.messages.success.completed"));
      if (this.sa.id == null) {
        this.$router.push({
          name: "EditB0401",
          query: {
            id: id,
          },
        });
      } else {
        this.load();
      }
    },
    packageUpload(data) {
      console.log(data);
      this.initDataByUpload(data);
    },
    checkDataByUpload(data, invoiceMap) {
      for (var j = 1; j < data.length; j++) {
        var row = data[j];
        if (!invoiceMap.has(String(row[3]))) {
          return false;
        }
      }
      return true;
    },
    initDataByUpload(data) {
      var partnerCode = data[1][0];
      data = data.filter((d) => d.length > 0);
      var invoiceNos = [];
      for (var i = 1; i < data.length; i++) {
        if (!data[i][4]) {
          this.$message("", "無償インボイスの場合、アップロードできません。");
          return;
        }
        if (invoiceNos.indexOf(data[i][3]) == -1) {
          invoiceNos.push(data[i][3]);
        }
      }
      let containerTypes = new Map();
      containerTypes.set("20F", "CONTAINER_TYPE-20F");
      containerTypes.set("40F", "CONTAINER_TYPE-40F");
      containerTypes.set("40FHQ", "CONTAINER_TYPE-40FHQ");

      this.$http
        .get(
          `/commercial-invoices/get-invoice?invoice=${invoiceNos.join(
            ","
          )}&partnerCode=${partnerCode}`
        )
        .then((res) => {
          if (!this.validInvoiceInput(res.data)) {
            return;
          }

          let invoiceMap = new Map();
          res.data.forEach((inv) => {
            invoiceMap.set(inv.invoiceNo, inv);
          });

          if (res.data.length > 0) {
            this.initPackageData(res.data[0]);
          }

          if (this.checkDataByUpload(data, invoiceMap)) {
            for (var j = 1; j < data.length; j++) {
              var row = data[j];
              var pkg;

              for (var k = 0; k < res.data.length; k++) {
                if (res.data[k].invoiceNo === String(row[3])) {
                  for (var l = 0; l < res.data[k].packages.length; l++) {
                    if (res.data[k].packages[l].poNo === String(row[4])) {
                      pkg = res.data[k].packages[l];
                      this.sa.packages.push({
                        ...pkg,
                        containerTypeId:
                          containerTypes.get(String(row[1])) || null,
                        containerNo: row[2] && row[2].replaceAll(" ", ""),
                        invoiceNo: row[3],
                        invoiceId: invoiceMap.get(String(row[3])).id,
                        lotNo: row[6],
                        totalQty: row[7],
                        flag: row[8],
                        cartonStartNo: row[9],
                        cartonEndNo: row[10],
                        shippedCarton: row[10] - row[9] + 1,
                        perCartonQty: row[12],
                        poNo: row[4],
                        totalNetWeight: row[13],
                        totalGrossWeight: row[14],
                        totalVolume: row[15],
                        seq: new Date().getTime() + j,
                      });
                      break;
                    }
                  }
                }
              }
            }
          } else {
            console.log("tip");
          }
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    getPoId(poNo) {
      return this.$http.get(`/purchase-orders/get-po-id?poNo=${poNo}`);
    },
    initPackageData(inv) {
      this.sa.partnerId = inv.partnerId;
      this.sa.blIssueDate = inv.blIssueDate;
      this.sa.loadingPortCode = inv.loadingPortCode;
      this.sa.dischargePortCode = inv.dischargePortCode;
      this.sa.etd = inv.etd;
      this.sa.transportModeId = inv.transportModeId;
      this.sa.currencyCode = inv.currencyCode;
    },

    validFields() {
      let fields = [
        "totalQty",
        "cartonStartNo",
        "cartonEndNo",
        "shippedCarton",
        "perCartonQty",
      ];
      if (
        this.$isSea(this.sa.transportModeId) &&
        this.sa.stackTypeId == "STACK_TYPE-FCL"
      ) {
        fields.push("containerNo", "containerTypeId");
      }
      return fields;
    },
    validData() {
      if (!this.validPortCode()) {
        this.$message("", "港コードが4桁になっています。");
        return false;
      }
      let fields = this.validFields();
      let filterPackages = this.sa.packages.filter((p) =>
        fields
          .map((field) => p[field] != null && p[field] != "")
          .reduce((x, y) => x && y, true)
      );

      for (var i = 0; i < this.sa.packages.length; i++) {
        var p = this.sa.packages[i];
        if (
          !p.totalQty ||
          !p.cartonStartNo ||
          !p.cartonEndNo ||
          !p.shippedCarton ||
          !p.perCartonQty
        ) {
          this.$message(
            this.$t("app.messages.errors.title"),
            this.$t("B0400.messages.errors.invalidContainerInfo") +
              "poNo:" +
              p.poNo
          );
          return false;
        }
        if (
          this.sa.stackTypeId == "STACK_TYPE-FCL" &&
          (!p.containerNo || !p.containerTypeId)
        ) {
          this.$message(
            this.$t("app.messages.errors.title"),
            this.$t("B0400.messages.errors.invalidContainerInfo") +
              "poNo:" +
              p.poNo
          );
          return false;
        }
        if (
          this.sa.stackTypeId == "STACK_TYPE-FCL" &&
          !this.$legalInput(p.containerNo)
        ) {
          this.$message(
            "",
            this.$t("app.validator.messages.illegalInput") +
              "containerNo:" +
              p.containerNo
          );
          return false;
        }

        if (
          (p.cartonEndNo - p.cartonStartNo + 1) * p.perCartonQty !=
          p.totalQty
        ) {
          this.$message(
            "",
            this.$t("B0400.messages.errors.per_carton_qty_invalid") +
              "poNo:" +
              p.poNo
          ); //'「入数＊carton数＝数量」ルールを守ってください。'
          return false;
        }

        if (!p.totalGrossWeight || !p.totalVolume || !p.totalNetWeight) {
          this.$message(
            "",
            this.$t("B0400.messages.errors.nw_gw_m3_require") + "poNo:" + p.poNo
          );
          //N/W G/W M3が必須入力項目です。ご確認ください。
          return false;
        }
        if (
          !(p.totalGrossWeight > 0 && p.totalVolume > 0 && p.totalNetWeight > 0)
        ) {
          this.$message(
            "",
            this.$t("B0400.messages.errors.nw_gw_m3_gt0") + "poNo:" + p.poNo
          );
          //'N/W,G/W,M3ゼロより大きい値を入力してください。'
          return false;
        }
      }
      if (this.M3BiggerThan100()) {
        this.$message("", this.$t("B0400.messages.errors.m3_more_than_100"));
        return false;
      }
      if (this.sameContainerNoDifType) {
        this.$message(
          "",
          "コンテナNo：" +
            this.sameContainerNoDifType +
            this.$t("B0400.messages.errors.ctn_no_save_type_diff")
          //'不整合が発生しています、ご確認ください。'
        );
        return false;
      }
      var errInvs = this.sa.packages.filter(
        (p) =>
          p.paid &&
          (p.incotermId === "INCOTERM-DAP" || p.incotermId === "INCOTERM-DDP")
      );
      if (errInvs.length > 0) {
        this.$message(
          "",
          "DAP/DDP建値のデータに対して、有償SAで登録できません。"
        );
        return false;
      }
      var errContainerNos = this.sa.packages.filter(
        (pkg) => pkg.containerNo && pkg.containerNo.indexOf(" ") > -1
      );
      if (errContainerNos.length > 0) {
        this.$message(
          "",
          "コンテナNOにスペースがあるので、スペースを消してください。"
        );
        return false;
      }
      return true;
    },
    M3BiggerThan100() {
      return this.isAir && this.totalM3 > 100;
      // if (this.isAir && this.totalM3 > 100) {
      //   this.$message('', this.$t('B0400.messages.errors.m3_more_than_100'))
      // }
    },
    uploadFile() {
      this.$refs.uploadFileDialog.popup();
    },
    archiveCancelApprove() {
      this.$refs.archiveCancelDialog.popup({
        resolve: () =>
          this.$http
            .put(
              `/shipping-advices/${this.sa.id}/archive-cancel-confirm?version=${this.sa.version}`
            )
            .then((res) => {
              if (res.data) {
                if (this.canCancel) {
                  this.$message("", "凍結後SA取消承認済み");
                } else if (this.canBlTurnBack) {
                  this.$message("", "凍結後SA一時保存戻し承認済み");
                }

                this.$router.push("/B0400");
              }
            })
            .catch((res) => this.$showError(res)),
        reject: () =>
          this.$http
            .put(`/shipping-advices/${this.sa.id}/archive-cancel-reject`)
            .then((res) => {
              if (res.data) {
                if (this.canCancel) {
                  this.$message("", "凍結後SA取消拒否済み");
                } else if (this.canBlTurnBack) {
                  this.$message("", "凍結後SA一時保存戻し拒否済み");
                }

                this.load();
              }
            })
            .catch((res) => this.$showError(res)),
      });
    },

    missNwGwM3() {
      return (
        this.sa.packages.filter(
          (p) => !p.totalGrossWeight || !p.totalVolume || !p.totalNetWeight
        ).length > 0
      );
    },
    nwGwM3BiggerThanZero() {
      return (
        this.sa.packages.filter(
          (p) =>
            p.totalGrossWeight > 0 && p.totalVolume > 0 && p.totalNetWeight > 0
        ).length === this.sa.packages.length
      );
    },
    findCustom() {
      return this.$http
        .get(`/shipping-advices/find-custom`, {
          params: {
            partnerId: this.sa.partnerId,
            dischargePortCode: this.sa.dischargePortCode,
            invoiceNo: this.sa.packages && this.sa.packages[0].invoiceNo,
          },
        })
        .then((res) => {
          this.$set(this.sa, "customsDirectorId", res.data.companyId);
        });
    },
    perCartonEqual() {
      return (
        this.sa.packages.filter(
          (p) =>
            (p.cartonEndNo - p.cartonStartNo + 1) * p.perCartonQty == p.totalQty
        ).length === this.sa.packages.length
      );
    },
    load() {
      return this.$http
        .get(`/shipping-advices/${this.sa.id}?view=B0401`)
        .then((res) => {
          this.sa = res.data;

          this.sa.packages.forEach((p, index) => {
            p.seq = new Date().getTime() + index * 1000;
          });
          this.sa.packages = this.sa.packages.sort((a, b) => {
            return a.seq - b.seq;
          });
        });
    },
    updateNGV(item) {
      console.log(
        this.sa.packages
          .filter((p) => p.invoiceNo === item.invoiceNo)
          .filter((p) => p.poNo === item.poNo)
      );
      this.sa.packages
        .filter((p) => p.invoiceNo === item.invoiceNo)
        .filter((p) => p.poNo === item.poNo)
        .forEach((p) => {
          p.totalNetWeight = item.totalNetWeight;
          p.totalGrossWeight = item.totalGrossWeight;
          p.totalVolume = item.totalVolume;
        });
    },
    sjlSend() {
      this.setRequiredAndNextTick("sjl", () => {
        if (!this.validData()) return;
        if (!this.$refs.form.validate()) return;
        this.changeBlNo();
        this.$http
          .put(`shipping-advices/${this.$route.query.id}?view=B0401`, this.sa)
          .then((saveRes) => {
            this.$http
              .put(`/shipping-advices/${this.sa.id}/sjl-send`)
              .then((res) => {
                if (this.isSytc) {
                  this.$router.push({
                    path: "/B0500",
                    query: {
                      blNo: saveRes.data.blNo,
                    },
                  });
                } else {
                  this.$message("", "SJLへ送信が完了しました。");
                  this.edit(res.data.id);
                }
              })
              .catch((err) => {
                if ("FILE_UPLOAD_FAILED" === err.response.data) {
                  this.$confirm({
                    content:
                      "INVPL資料はテンプに失敗しました、まだSJLへ送信しますか？",
                    action: "送信",
                  })
                    .then(() => {
                      this.$http
                        .put(`/shipping-advices/${this.sa.id}/trigger-sjl-send`)
                        .then((res) => {
                          this.$message("", "SJLへ送信が完了しました。");
                          this.edit(saveRes.data.id);
                        });
                    })
                    .catch(() => {});
                } else if ("URL_ERROR" === err.response.data) {
                  this.$message("", "URL ERROR");
                } else {
                  this.$message("", "INTERNAL ERROR");
                }
              });
          })
          .catch((res) => {
            if (res.response.status === 500) {
              if (res.response.data.message == "BL_NO_DUPLICATE") {
                this.$message(
                  this.$t("app.messages.errors.title"),
                  this.$t("B0400.messages.errors.invalidBlNo")
                );
              } else if (res.response.data.message == "PACKAGE_QTY_OVER") {
                this.$message(
                  this.$t("app.messages.errors.title"),
                  this.$t("B0400.messages.errors.package_qty_over")
                ); //'既存の数量を越えてしまいました。'
              } else {
                this.$message(
                  this.$t("app.messages.errors.title"),
                  this.$t("app.system.error") //`system error, module:${this.$route.path}`
                );
              }
            }
          });
      });
    },
    partnerSaTurnBack() {
      this.$http
        .put(`/shipping-advices/${this.sa.id}/partner-turn-back`)
        .then(() => {
          this.load();
          this.$message("", "SA戻す(シッパー)が完了しました。");
        })
        .catch(() => {
          this.load();
          this.$message("", "ERROR");
        });
    },

    saUpdateAfterSendMail() {
      this.$confirm({
        content:
          "SA変更を行うと、コンテナ明細などの各帳票も更新されます。変更後は各担当者に適宜連絡をお願いいたします。",
        action: "確認",
        cancelAction: "キャンセル",
      })
        .then(() => {
          this.$http
            .put(
              `/shipping-advices/${this.sa.id}/sa-update-after-send-mail?version=${this.sa.version}`,
              {
                forwarder: this.sa.forwarderId,
                customsCompany: this.sa.customsDirectorId,
                packages: this.sa.packages,
              }
            )
            .then((res) => {
              let message = "";
              if (res.data.forwarder) {
                message += "船社・航空会社コードの変更が完了しました。";
              }
              if (res.data.customsCompany) {
                message += "通関業者の変更が完了しました。";
              }
              if (res.data.containerSize) {
                message += "コンテナサイズの変更が完了しました。";
              }
              if (
                !res.data.forwarder &&
                !res.data.customsCompany &&
                !res.data.containerSize
              ) {
                message = "何も変わっていません";
              }
              this.$message("", message);
              this.load();
            })
            .catch((err) => {
              this.$showError(err);
            });
        })
        .catch(() => {});
    },
    validPortCode() {
      return (
        this.sa.loadingPortCode.length <= 3 &&
        this.sa.dischargePortCode.length <= 3
      );
    },
  },
  watch: {
    "sa.stackTypeId"() {
      if (!this.isSeaFcl && this.sa.packages) {
        this.sa.packages.forEach((pkg) => {
          pkg.containerNo = null;
          pkg.containerTypeId = null;
        });
      }
    },
    "sa.transportModeId"() {
      if (this.sa.transportModeId === "TRANSPORT_MODE-AIR") {
        this.sa.stackTypeId = null;
      }
      if (!this.isSeaFcl && this.sa.packages) {
        this.sa.packages.forEach((pkg) => {
          pkg.containerNo = null;
          pkg.containerTypeId = null;
        });
      }
    },
    "sa.partnerId"() {
      if (
        this.sa.packages &&
        this.sa.partnerId &&
        this.sa.dischargePortCode &&
        this.sa.customsDirectorId == null
      ) {
        this.findCustom();
      }
    },
    "sa.dischargePortCode"() {
      if (
        this.sa.packages &&
        this.sa.partnerId &&
        this.sa.dischargePortCode &&
        this.sa.customsDirectorId == null
      ) {
        this.findCustom();
      }
    },
  },
  mounted() {
    this.sa = this.$route.params.sa || this.sa;
    this.sa.specialId = this.sa.specialId || "SPECIAL-NONE";
  },
};
</script>
